import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import '../../styles/Networks.css'; 
import '../../styles/Fonts.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; 

import cab from '../../assets/logo/cab.webp';
import dof from '../../assets/logo/dof.webp';
import dti from '../../assets/logo/dti_logo.webp';
import peza from '../../assets/logo/pezza.webp';
import scmap from '../../assets/logo/scmap1.webp';
import lognet from '../../assets/logo/lognet1.webp';
import x2 from '../../assets/logo/X2-Logo.webp';

const Networks = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const settings = {
    dots: false,
    infinite: true, // Enable infinite scrolling
    speed: 5000, // Long duration for seamless movement
    slidesToShow: 5, // Number of visible slides
    slidesToScroll: 1, // Number of slides to scroll at once
    autoplay: true, // Enable autoplay
    autoplaySpeed: 0, // No delay between transitions for continuous effect
    cssEase: "linear", // Linear easing for smooth, continuous scroll
    pauseOnHover: false, // Don't pause on hover
    responsive: [
        {
            breakpoint: 768, // For tablets and smaller devices
            settings: {
                slidesToShow: 2, // Show 2 slides for smaller screens
            },
        },
        {
            breakpoint: 576, // For mobile devices
            settings: {
                slidesToShow: 1, // Show 1 slide for the smallest screens
            },
        },
    ],
};

  const licenseLogos = [
    { src: cab, alt: "CAB" },
    { src: dof, alt: "DOF" },
    { src: dti, alt: "DTI" },
    { src: peza, alt: "PEZA" },
    { src: scmap, alt: "SCMAP" }
  ];


  return (
    <section id="networks" className="networks-preview-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">TRUSTED PARTNERSHIPS</div>
          <h2 className="section-title">License & Accreditation</h2>
          <p className="section-description">
            Recognized by leading organizations and regulatory bodies for our commitment to excellence and compliance.
          </p>
        </div>

        <div className="licenses-carousel-container">
          {isMobile ? (
            // Mobile: Use Swiper for better performance
            <Swiper
              modules={[Autoplay]}
              spaceBetween={20}
              slidesPerView={2}
              centeredSlides={false}
              loop={true}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              speed={8000}
              allowTouchMove={false}
              breakpoints={{
                480: {
                  slidesPerView: 2.5,
                },
                640: {
                  slidesPerView: 3,
                },
              }}
              className="licenses-slider"
            >
              {licenseLogos.map((logo, index) => (
                <SwiperSlide key={index}>
                  <img src={logo.src} alt={logo.alt} className="license-logo" />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            // Desktop: Use Slick
            <Slider {...settings} className="licenses-slider">
              <div><img src={cab} alt="CAB" className="license-logo" /></div>
              <div><img src={dof} alt="DOF" className="license-logo" /></div>
              <div><img src={dti} alt="DTI" className="license-logo" /></div>
              <div><img src={peza} alt="PEZA" className="license-logo" /></div>
              <div><img src={scmap} alt="SCMAP" className="license-logo" /></div>
            </Slider>
          )}
        </div>

        <div className="networks-content">
          <div className="networks-header">
            <h3 className="networks-title" style={{ fontWeight: 'bold' }}>Global Networks</h3>
            <p className="networks-subtitle">Strategic partnerships that expand our reach worldwide</p>
          </div>
          
          <div className="networks-logos">
            <div className="network-logo-item">
              <img src={lognet} alt="LogNet Partners" className="network-logo" />
            </div>
            <div className="network-logo-item">
              <img src={x2} alt="X2 Logistics Networks" className="network-logo" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Networks;
